import { useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { formatDateAsAnniversary } from 'helpers/dateTimes';

import { useUpdateMenuFromGsheetMutation } from 'data/__generated__';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

export function UpdateMenusFromGsheetButton({ date }: { date: Date }) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [updateMenuFromGsheet, { loading }] = useUpdateMenuFromGsheetMutation();

    async function handleClick() {
        await updateMenuFromGsheet({
            variables: {
                mondayDate: formatDateAsAnniversary({ dateTime: date, useNewFormat: true }),
            },
            onCompleted: ({ updateMenuFromGsheet }) => {
                if (updateMenuFromGsheet?.success) {
                    toast.success('Les menus ont bien été mis à jour depuis le GSheet');
                } else {
                    toast.error(`Une erreur s'est produite : ${updateMenuFromGsheet?.error || 'erreur inconnue'}`);
                }
            },
            onError: (error) => {
                toast.error(`Impossible de mettre à jour les menus depuis le GSheet : ${error}`);
            },
        });
    }

    return (
        <>
            <TotemPopup
                title="Confirmer la mise à jour des menus depuis le GSheet"
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                contentOverflow="visible"
            >
                <InfoText>
                    En confirmant vous remplacerez les quantités des menus existants pour la semaine du{' '}
                    {formatDateAsAnniversary({ dateTime: date })}.
                </InfoText>
                <TotemPrimaryLoadingButton loading={loading} onClick={handleClick} label="Confirmer" useIcon={false} />
            </TotemPopup>
            <TotemPrimaryButton disabled={loading} onClick={() => setIsOpen(true)}>
                GSheet
            </TotemPrimaryButton>
        </>
    );
}

const InfoText = styled.div`
    padding: 20px 0px;
`;
